import React, { Component } from "react";

import Chat from "./Chat";
//import ChatGroup from "./ChatGroup";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import FindReplaceOutlinedIcon from '@material-ui/icons/FindReplaceOutlined';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

//const styles = theme => ({
//	[theme.breakpoints.down('sm')]:{
//		bigcell: {
//			maxWidth:'150px',
//			minWidth:'50px'
//		},
//		medcell: {
//			maxWidth:'50px',
//			minWidth:'50px'
//		},
//		smallcell: {
//			maxWidth:'15px',
//			minWidth:'15px'
//		},
//	},
//	[theme.breakpoints.up('md')]:{
//		bigcell: {
//			maxWidth:'150px',
//			minWidth:'50px'
//		},
//		medcell: {
//			maxWidth:'50px',
//			minWidth:'50px'
//		},
//		smallcell: {
//			maxWidth:'50px',
//			minWidth:'50px'
//		},
//	},
//	setoverflow:{
//		overflow:'hidden',
//		display: 'block'
//	}
//});

class ProjectRow extends Component {
	constructor() {
		super();
		this.state= {
			isOpen: false,
		}
		this.downloadTranslation = this.downloadTranslation.bind(this);
		this.switchOpen = this.switchOpen.bind(this);
		this.linkToProjectForm = this.linkToProjectForm.bind(this);
	}

	downloadTranslation(){
		if(typeof this.props.trgDocument !== 'undefined'){
			return <Tooltip title="Download translation"><a target="_blank" href={this.props.trgDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.trgDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a></Tooltip>;
		}else{
			return '';
		}
	}
	
	switchOpen(){
		this.setState(prevState => ({isOpen: !prevState.isOpen}));
	}
	
	linkToProjectForm(){
		if(this.props.userRole == 'ADMIN'){
			return <Link  to={`/projectForm/${this.props.id}`}>{this.props.code}</Link>
		}else{
			return this.props.code;
		}
	}
	
	render() {
		let accions="";
		let dateF="";
		let stateIcon=<Tooltip title="Progress"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat}}>&#59425;</Icon></Tooltip>;;
		let colorEstat="#000";
		let atachment='';
		var chat;
		
		if(this.props.urgent>0){
			colorEstat="#f00";
		}
		
		if(typeof this.props.trgDocument !== 'undefined'){
			if(!this.props.urgent>0){
					colorEstat="#00b800";
			}
			accions = <span>{this.downloadTranslation()}</span>;
			dateF = this.props.finished.length>1 ? new Intl.DateTimeFormat('es-ES', {}).format(new Date(this.props.finished)) : "";
			stateIcon = <Tooltip title="Completed"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: colorEstat }}>&#59427;</Icon></Tooltip>;
		}else if(this.props.splitDocument){
			stateIcon = "";
		}
		
		const rowColor = this.props.splitDocument ? "#d8ddf7":"#c1ceff";
		const documento = this.props.splitDocument ? "":<span>{atachment}<Tooltip title={this.props.description}><a target="_blank" href={this.props.orgDoc.href+"/content?access_token="+this.props.accessToken} title={this.props.orgDoc.title}>{this.props.description}</a></Tooltip></span>;
		const idiomas = this.props.splitDocument ? "":<span>{atachment}<Tooltip title={this.props.description}><a target="_blank" href={this.props.orgDoc.href+"/content?access_token="+this.props.accessToken} title={this.props.orgDoc.title}>{this.props.description}</a></Tooltip></span>;
		//-------------------------------------------------------------------
		// ChatList per si no es veuen les linies del projecte
		//-------------------------------------------------------------------
		//let chatList = [];
		//if(this.props.userRole=='CUSTOMER'){
		//	for(let i=0; i<this.props.orderRows.length ;++i){
		//		let tooltip = this.props.orderRows[i].props.langPair.length>10 ? this.props.orderRows[i].props.langPair.slice(-5) : this.props.orderRows[i].props.langPair;
		//		let chat = <Chat
		//						orderId={this.props.orderRows[i].props.id}
		//						messages={this.props.orderRows[i].props.messages}
		//						sendMessage={this.props.sendMessage}
		//						tooltip={tooltip}
		//					/>
		//		chatList.push(chat);
		//	}
		//}
		//-------------------------------------------------------------------
		
		return (
		<React.Fragment>
			<tr hover key={this.props.id} style={{background: rowColor}}>
			<td className="medcell d-none d-lg-table-cell">
				<IconButton
					aria-label="expand row"
						size="small"
						onClick={this.switchOpen}
					>
						{this.state.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
				</IconButton>
			</td>
			
			<td className="bigcell d-none d-lg-table-cell">
				<Tooltip title={this.props.customer}><span>{this.props.customer}</span></Tooltip>
			</td>
			<td className="smallcell">
				<IconButton className="d-lg-none"
					aria-label="expand row"
						size="small"
						onClick={this.switchOpen}
					>
						{this.state.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
				</IconButton>
				<Tooltip title={this.props.code}><span>{this.linkToProjectForm()}</span></Tooltip>
			</td>
			<td>

			</td>
			<td className="bigcell">{documento}</td>
			<td>{ this.props.splitDocument ? "":this.props.lang}</td>
			<td>
				{stateIcon}
			</td>
			{this.props.viewTranslators &&  <td className="medcell d-none d-lg-table-cell"></td>}
			{this.props.viewTranslators &&  <td className="medcell d-none d-lg-table-cell"></td>}
			<td></td>
			<td className="d-none d-lg-table-cell"><Tooltip title={new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',  minute: 'numeric', hour12: false}).format(new Date(this.props.recvd))}><span>{new Intl.DateTimeFormat('es-ES', {year: '2-digit', month: 'numeric', day: 'numeric'}).format(new Date(this.props.recvd))}</span></Tooltip></td>
			<td className="d-none d-lg-table-cell">{dateF}</td>
			<td>{accions}</td>
			</tr>
			{this.state.isOpen ? this.props.orderRows : ""}
		</React.Fragment>
		);
	}
}
//<TableCell><IconButton style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000"}}>&#59397;</IconButton></TableCell>
function EditIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M2 12.88V16h3.12L14 7.12 10.88 4 2 12.88zm14.76-8.51c.33-.33.33-.85 0-1.18l-1.95-1.95c-.33-.33-.85-.33-1.18 0L12 2.88 15.12 6l1.64-1.63z" />
    </SvgIcon>
  );
}

export default ProjectRow;